/// <amd-module name="Search/Shared/Components/ZeroData" />
export * from "./ZeroData/index";
